import { cn } from "@/lib/utils";

interface IncludeExcludeToggleProps {
  id?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
}

export function IncludeExcludeToggle({
  id,
  checked,
  onCheckedChange,
  className,
  disabled,
}: IncludeExcludeToggleProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onCheckedChange(!checked);
      }}
      className={cn(
        "relative inline-flex h-7 w-24 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        checked ? "bg-[#5A5DF6]" : "bg-gray-200",
        disabled && "opacity-50 cursor-not-allowed",
        className,
      )}
    >
      <span
        className={cn(
          "absolute h-5 w-5 rounded-full bg-white shadow-sm transition-transform",
          checked ? "translate-x-[4.25rem]" : "translate-x-1",
        )}
      />
      <span
        className={cn(
          "w-full text-xs font-medium transition-colors",
          checked ? "text-white pr-6 pl-2" : "text-gray-600 pl-6 pr-2",
        )}
      >
        {checked ? "Include" : "Exclude"}
      </span>
    </button>
  );
}
